<template>
  <div class="row">
    <div class="col-md-12" style="margin: -15px;">
      <div class="card card-sm">
        <div class="card-header" style="background-color: #DBECDB;">
          <h5 class="card-title">Gestión de Salidas {{ unidad }}</h5>
          <div class="row mb-3">
            <div class="col-md-2">
              <label class="form-label small">Fecha desde</label>
              <input
                v-model="filters.fecha_desde"
                type="date"
                class="form-control form-control-sm"
              >
            </div>
            <div class="col-md-2">
              <label class="form-label small">Fecha hasta</label>
              <input
                v-model="filters.fecha_hasta"
                type="date"
                class="form-control form-control-sm"
              >
            </div>
            <div class="col-md-4">
              <label class="form-label small">Unidad/Sub Direccion</label>
              <select
                v-model="filters.unidad"
                class="form-select"
                @change="fetchUsuarios"
              >
                <option value="">Todas las unidades</option>
                <option v-for="unidad in unidades" :key="unidad.id" :value="unidad.id">
                  {{ unidad.codigo }} - {{ unidad.nombre_unidad }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label small">Solicitado Por</label>
              <select
                v-model="filters.usuario"
                class="form-select"
              >
                <option value="">Todos</option>
                <option v-for="usuario in usuarios" :key="usuario.id" :value="usuario.id">
                  {{ usuario.nombres }} {{ usuario.paterno }} {{ usuario.materno }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <div class="form-group">
                <div class="input-group">
                  <input
                    v-model="filters.search"
                    type="text"
                    class="form-control"
                    placeholder="Buscar por detalle o unidad..."
                  >
                  <select
                    v-model="filters.estado"
                    class="form-select"
                    style="max-width: 150px;"
                  >
                    <option value="">Todos</option>
                    <option value="pendiente">Pendientes</option>
                    <option value="solicitada">Solicitadas</option>
                    <option value="aprobada">Aprobadas</option>
                    <option value="rechazada">Rechazadas</option>
                    <option value="completada">Completadas</option>
                  </select>
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    @click="handleSearch"
                  >
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-md-5 text-end">
              <BButton
                class="btn-round me-2"
                variant="secondary"
                type="button"
                @click="clearDateFilters"
              > <i class="fa fa-eraser me-1"></i> Limpiar
              </BButton>

              <BButton
                v-if="hasPermission('salida_create')"
                @click="showModal(null)"
                variant="primary"
                class="btn-round me-2"
              >
                <i class="fa fa-plus me-1"></i> Nueva Solicitud
              </BButton>
              <BButton
                variant="danger"
                class="btn-round"
                @click="generatePDF"
              >
                <i class="fa fa-file-pdf me-1"></i> PDF
              </BButton>
            </div>
          </div>
        </div>

        <div class="card-body">
          <div v-if="loading" class="text-center">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando...</span>
            </div>
          </div>

          <div v-else>
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover table-bordered">
                <thead class="text-primary">
                  <tr style="line-height: 8px; font-size: 0.8rem;">
                    <th>Nro.</th>
                    <th>Fecha</th>
                    <th>Unidad</th>
                    <th>Detalle</th>
                    <th>Items</th>
                    <th>Solicitud</th>
                    <th>Autorizacion</th>
                    <th>Despacho</th>
                    <th>Nota</th>
                    <th>Acta</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="solicitud in solicitudes.data" :key="solicitud.id">
                    <td>{{ solicitud.numero }}</td>
                    <td>{{ formatDate(solicitud.fecha_solicitud) }}</td>
                    <td>{{ solicitud.unidad.codigo }} : {{ solicitud.unidad.nombre_unidad }}</td>
                    <td>{{ solicitud.detalle_solicitud }}</td>
                    <td>{{ solicitud.detalles.length }}</td>
                    <td>
                      <BBadge :variant="getBadgeVariant(solicitud.estado_solicitud)">
                        {{ solicitud.estado_solicitud }}
                      </BBadge>
                      <div v-if="solicitud.fecha_solicitud" class="mt-1">
                        <BBadge variant="success"> {{ formatDate(solicitud.fecha_solicitud) }}</BBadge>
                      </div>
                    </td>
                    <td>
                      <BBadge :variant="getBadgeVariant(solicitud.estado_autorizacion)">
                        {{ solicitud.estado_autorizacion }}
                      </BBadge>
                      <div v-if="solicitud.fecha_autorizacion" class="mt-1">
                        <BBadge variant="success"> {{ formatDate(solicitud.fecha_autorizacion) }}</BBadge>
                      </div>
                    </td>
                    <td>
                      <div v-if="solicitud.fecha_despacho" class="mt-1">
                        <BBadge variant="success">Entregado</BBadge>
                      </div>
                      <div v-if="solicitud.fecha_despacho" class="mt-1">
                        <BBadge variant="success"> {{ formatDate(solicitud.fecha_despacho) }}</BBadge>
                      </div>
                    </td>
                    <td>
                      <BButton
                        v-if="solicitud.estado_solicitud!='pendiente'"
                        variant="info"
                        size="sm"
                        class="me-1"
                        @click="generateNotaPDF(solicitud.id)"
                      >
                        <i class="fa fa-file-pdf me-1"></i>
                      </BButton>
                    </td>
                    <td>
                      <BButton
                        v-if="solicitud.estado_autorizacion=='aprobada'"
                        variant="success"
                        size="sm"
                        class="me-1"
                        @click="generateActaSalida(solicitud.id)"
                      >
                        <i class="fa fa-file-pdf me-1"></i>
                      </BButton>
                    </td>
                    <td>
                      <div class="btn-group">
                        <BButton
                          @click="showDetails(solicitud.id)"
                          variant="info"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-eye"></i>
                        </BButton>
                        <!-- v-if="hasPermission('despachar_solicitudes') && solicitud.estado_solicitud === 'aprobada' && !solicitud.fecha_despacho"  -->
                        <!--                        <BButton
                          v-if="hasPermission('despachar_solicitudes') && solicitud.estado_solicitud === 'aprobada'"
                          @click="despacharSolicitud(solicitud)"
                          variant="warning"
                          size="sm"
                          class="me-1"
                        >
                          <i class="fa fa-truck"></i> Despachar
                        </BButton>
                        -->

                        <!-- v-if="solicitud.estado_solicitud === 'pendiente' && hasPermission('autorizar_solicitudes')" -->
                        <!--
                        <div v-if="solicitud.estado_solicitud === 'pendiente' && hasPermission('autorizar_solicitudes')">
                          <BButton
                            @click="showAprobarModal(solicitud)"
                            variant="success"
                            size="sm"
                            class="me-1"
                          >
                            <i class="fa fa-check"></i>
                          </BButton>
                          <BButton
                            @click="showRechazarModal(solicitud)"
                            variant="danger"
                            size="sm"
                            class="me-1"
                          >
                            <i class="fa fa-times"></i>
                          </BButton>
                        </div>
                        -->
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row mt-3" v-if="solicitudes.total > 0">
              <div class="col-md-12">
                <BPagination
                  v-model="pagination.current_page"
                  :total-rows="solicitudes.total"
                  :per-page="pagination.per_page"
                  @update:model-value="handlePageChange"
                  align="center"
                ></BPagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal básico para crear solicitud -->
    <BModal
      v-model="modalVisible"
      :title="'Nueva Solicitud'"
      size="lg"
      centered
      hide-footer
    >
      <form @submit.prevent="handleSubmit">
        <div class="row mt-3">
          <label class="form-label col-md-2">Detalle</label>
          <div class="col-md-10">
            <div class="form-group">
              <textarea
                v-model="form.detalle_solicitud"
                class="form-control"
                :class="{ 'is-invalid': errors.detalle_solicitud }"
                rows="3"
                required
                placeholder="Describa el motivo de la solicitud"
              ></textarea>
              <div class="invalid-feedback" v-if="errors.detalle_solicitud">
                {{ errors.detalle_solicitud[0] }}
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="modalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="primary"
            :disabled="loadingForm"
          >
            <span v-if="loadingForm" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Guardar
          </BButton>
        </div>
      </form>
    </BModal>

    <!-- Modales de aprobación/rechazo -->
    <BModal
      v-model="aprobarModalVisible"
      title="Aprobar Solicitud"
      size="md"
      centered
      hide-footer
    >
      <form @submit.prevent="handleAprobar">
        <div class="form-group">
          <label class="form-label">Observación (Opcional)</label>
          <textarea
            v-model="aprobarForm.observacion"
            class="form-control"
            rows="3"
          ></textarea>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="aprobarModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="success"
            :disabled="loadingForm"
          >
            Aprobar
          </BButton>
        </div>
      </form>
    </BModal>

    <BModal
      v-model="rechazarModalVisible"
      title="Rechazar Solicitud"
      size="md"
      centered
      hide-footer
    >
      <form @submit.prevent="handleRechazar">
        <div class="form-group">
          <label class="form-label">Motivo del rechazo</label>
          <textarea
            v-model="rechazarForm.observacion"
            class="form-control"
            rows="3"
            required
          ></textarea>
        </div>

        <div class="modal-footer mt-3">
          <BButton
            type="button"
            variant="secondary"
            @click="rechazarModalVisible = false"
            class="me-2"
          >
            Cancelar
          </BButton>
          <BButton
            type="submit"
            variant="danger"
            :disabled="loadingForm"
          >
            Rechazar
          </BButton>
        </div>
      </form>
    </BModal>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { useAuthStore } from '@/stores/authStore';
import Swal from 'sweetalert2';
import { BModal, BButton, BPagination, BBadge } from 'bootstrap-vue-3';

const router = useRouter();
const authStore = useAuthStore();

// Datos
const solicitudes = ref({ data: [] });
const unidades = ref([]);
const usuarios = ref([]);
const loading = ref(true);
const modalVisible = ref(false);
const aprobarModalVisible = ref(false);
const rechazarModalVisible = ref(false);
const loadingForm = ref(false);
const errors = ref({});
const userRoles = computed(() => {
  return authStore.user?.roles || [];
});

// Verificar si tiene un rol específico
const hasRole = (roleName) => {
  const roles = userRoles.value;
  if (!roles || roles.length === 0) return false;

  return roles.some(role =>
    role?.toString()?.trim()?.toLowerCase() === roleName?.toString()?.trim()?.toLowerCase()
  );
};
// Filtros y paginación
const filters = ref({
  search: '',
  estado: '',
  unidad: '',
  usuario: '',
  fecha_desde: '',
  fecha_hasta: ''
});

const pagination = ref({
  current_page: 1,
  per_page: 10,
  total: 0
});
// Establecer filtro inicial según el rol
const setInitialFilter = () => {
  console.log('Roles del usuario:', userRoles.value); // Para depuración
  if (hasRole('Administrador')) {
    filters.value.estado = 'pendiente';
    console.log('Filtro establecido a: pendiente (Administrador)');
  } else if (hasRole('Almacen')) {
    filters.value.estado = 'aprobada';
    console.log('Filtro establecido a: aprobada (Almacén)');
  } else {
    filters.value.estado = ''; // Otros roles ven todos
    console.log('Filtro establecido a: todos');
  }
};
// Formularios
const form = ref({
  id_unidad: '',
  detalle_solicitud: ''
});

const aprobarForm = ref({
  id: null,
  observacion: ''
});

const rechazarForm = ref({
  id: null,
  observacion: ''
});

const id_unidad_user = computed(() => {
  return authStore.user?.user?.unidad || '';
});

// Métodos
const fetchSolicitudes = async () => {
  loading.value = true;
  try {
    const params = {
      page: pagination.value.current_page,
      per_page: pagination.value.per_page,
      search: filters.value.search,
      estado: filters.value.estado,
      unidad: filters.value.unidad,
      usuario: filters.value.usuario,
      fecha_desde: filters.value.fecha_desde,
      fecha_hasta: filters.value.fecha_hasta
    };
    // Eliminar parámetros vacíos
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    });

    const response = await axios.get('/salidas/list', { params });
    if (response.data.success && response.data.data) {
      const paginatedData = response.data.data;

      // Asignar los datos de solicitudes (están en data.data)
      solicitudes.value = {
        data: paginatedData.data,
        total: paginatedData.total,
        current_page: paginatedData.current_page,
        last_page: paginatedData.last_page,
        per_page: paginatedData.per_page,
        from: paginatedData.from,
        to: paginatedData.to
      };

      // Actualizar la paginación
      pagination.value = {
        current_page: paginatedData.current_page,
        per_page: paginatedData.per_page,
        total: paginatedData.total
      };
    }
  } catch (error) {
    console.error('Error al cargar solicitudes:', error);
    Swal.fire('Error', 'No se pudieron cargar las solicitudes', 'error');
  } finally {
    loading.value = false;
  }
};

// Añadir método para limpiar filtros de fecha
const clearDateFilters = () => {
  filters.value.fecha_desde = '';
  filters.value.fecha_hasta = '';
  filters.value.unidad = '';
  filters.value.usuario = '';
  filters.value.search = '';
  filters.value.estado = '';
  handleSearch();
};

const fetchUnidades = async () => {
  try {
    const response = await axios.get('/unidad/select');
    unidades.value = response.data.unidades;
  } catch (error) {
    console.error('Error al cargar unidades:', error);
  }
  fetchUsuarios();
};

const fetchUsuarios = async () => {
  try {
    const params = {};
    if (filters.value.unidad) params.id_unidad = filters.value.unidad;
    if (filters.id_area) params.id_area = filters.id_area;

    const response = await axios.get('/tipotramite/selectecnico', { params });
    usuarios.value = response.data.tecnicos || [];
  } catch (error) {
    console.error('Error al cargar técnicos:', error);
  }
};

const showModal = () => {
  form.value = { id_unidad: '', detalle_solicitud: '' };
  errors.value = {};
  modalVisible.value = true;
};
const showDetails = (solicitudId) => {
  router.push({ name: 'salidas-detalle', params: { id: solicitudId } });
};

const handleSubmit = async () => {
  loadingForm.value = true;
  errors.value = {};

  try {
    const response = await axios.post('/salidas/save', form.value);

    Swal.fire('Éxito', response.data.message, 'success');
    modalVisible.value = false;
    fetchSolicitudes();
  } catch (error) {
    if (error.response?.status === 422) {
      errors.value = error.response.data.errors;
    } else {
      Swal.fire('Error', error.response?.data?.message || 'Error al guardar', 'error');
    }
  } finally {
    loadingForm.value = false;
  }
};

const handleAprobar = async () => {
  loadingForm.value = true;

  try {
    const response = await axios.post(`/salidas/${aprobarForm.value.id}/aprobar`, aprobarForm.value);
    Swal.fire('Éxito', response.data.message, 'success');
    aprobarModalVisible.value = false;
    fetchSolicitudes();
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al aprobar', 'error');
  } finally {
    loadingForm.value = false;
  }
};

const handleRechazar = async () => {
  loadingForm.value = true;

  try {
    const response = await axios.post(`/salidas/${rechazarForm.value.id}/rechazar`, rechazarForm.value);
    Swal.fire('Éxito', response.data.message, 'success');
    rechazarModalVisible.value = false;
    fetchSolicitudes();
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al rechazar', 'error');
  } finally {
    loadingForm.value = false;
  }
};
const despacharSolicitud = async (solicitud) => {
  try {
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmar Despacho',
      text: `¿Despachar la solicitud #${solicitud.id}?`,
      icon: 'question',
      showCancelButton: true
    });

    if (isConfirmed) {
      const response = await axios.post(`/salidas/${solicitud.id}/despachar`);
      Swal.fire('Éxito', response.data.message, 'success');
      fetchSolicitudes(); // Recargar la lista
    }
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al despachar', 'error');
  }
};
const generateActaSalida = async (solicitud) => {
  try {
    const response = await axios.get(`/salidas/${solicitud}/nota-salida`, {
        responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'nota-solicitud.pdf';
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
      console.error('Error al generar PDF:', error);
  }
};

const generateNotaPDF = async (solicitud) => {
  try {
    const response = await axios.get(`/salidas/${solicitud}/nota-solicitud`, {
        responseType: 'blob'
    });

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'nota-solicitud.pdf';
    link.click();
    URL.revokeObjectURL(link.href);
  } catch (error) {
      console.error('Error al generar PDF:', error);
  }
};
const generarNotaSalida = async (solicitud) => {
  try {
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmar',
      text: `¿Generar nota de salida para la solicitud #${solicitud.id}?`,
      icon: 'question',
      showCancelButton: true
    });

    if (isConfirmed) {
      const response = await axios.post(`/salidas/${solicitud.id}/nota-salida`);
      Swal.fire('Éxito', response.data.message, 'success');
      fetchSolicitudes();
    }
  } catch (error) {
    Swal.fire('Error', error.response?.data?.message || 'Error al generar nota', 'error');
  }
};

const handleSearch = () => {
  pagination.value.current_page = 1;
  fetchSolicitudes();
};

const handlePageChange = (page) => {

  pagination.value.current_page = page;
  fetchSolicitudes();
  fetchUsuarios();
};

const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  return new Date(dateString).toLocaleDateString('es-BO', options);
};

const getBadgeVariant = (estado) => {
  const variants = {
    pendiente: 'warning',
    aprobada: 'success',
    rechazada: 'danger',
    completada: 'primary'
  };
  return variants[estado] || 'secondary';
};

const generatePDF = async () => {
  try {
    const params = {
      estado: filters.value.estado,
      unidad: filters.value.unidad,
      usuario: filters.value.usuario,
      fecha_desde: filters.value.fecha_desde,
      fecha_hasta: filters.value.fecha_hasta
    };

    // Eliminar parámetros vacíos
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    });

    const response = await axios.get('/salidas/reporte/generar-filtrado', {
      params: params,
      responseType: 'blob'
    });

    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `reporte-solicitudes-${new Date().toISOString().split('T')[0]}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    Swal.fire('Error', 'No se pudo generar el PDF', 'error');
  }
};

const hasPermission = (permission) => {
  return authStore.user?.permissions?.includes(permission);
};

// Inicialización
onMounted(() => {
  setInitialFilter();
  fetchSolicitudes();
  fetchUnidades();
  fetchUsuarios();
});
</script>

<style scoped>
.card-header {
  background-color: #DBECDB;
}
.table-responsive {
  max-height: 600px;
  overflow-y: auto;
}
thead th {
  background-color: #D84315;
  color:#ffffff;
  position: sticky;
  top: 0;
}
.btn-round {
  border-radius: 50px;
}
</style>
